import { makeStyles } from "@material-ui/core";
import React from "react";
import { SaveButton, Toolbar as RaToolbar } from "react-admin";

const useStyles = makeStyles((theme) => ({
	toolbar: {
		paddingLeft: theme.spacing(2),
		justifyContent: "space-between",
		display: "flex",
	},
	button: {
		marginRight: theme.spacing(1),
		overflow: "hidden",
	},
}));

const Toolbar = ({ basePath, ...props }) => {
	const classes = useStyles();
	return (
		<RaToolbar {...props} className={classes.toolbar}>
			<SaveButton
				label="resources.user-payments.buttons.upload_invoice"
				className={classes.button}
				redirect="list"
				disabled={props.pristine}
				submitOnEnter={true}
			/>
		</RaToolbar>
	);
};

export default Toolbar;
